import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SpecialitiesComponent } from './components/specialities.component';
import { DialogOverlayModule } from '../dialog-overlay/dialog-overlay.module';
import { ChipsSelectorFormFieldModule } from '../ui-components';



@NgModule({
    declarations: [
        SpecialitiesComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DialogOverlayModule,
        ChipsSelectorFormFieldModule
    ],
    exports: [
        SpecialitiesComponent
    ],
})
export class SpecialitiesModule {
}
